import moment from 'moment'
import React, { Component } from 'react'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
import Col from 'reactstrap/lib/Col'
import Container from 'reactstrap/lib/Container'
import Row from 'reactstrap/lib/Row'
import { convertDate } from '../../helper'
import { CONSTANT } from '../../helper/AllConastant'
import NoContentFound from '../common/NoContentFound'

class RmDomesticListing extends Component {

    renderSerialNumber = () => {
        return <>Sr. <br />No. </>
    }

    renderCostingHead = () => {
        return <>Costing <br />Head </>
    }

    renderRawMaterial = () => {
        return <>Raw <br />Material </>
    }

    renderRMGrade = () => {
        return <>RM <br />Grade </>
    }

    renderRMSpec = () => {
        return <>RM <br />Spec </>
    }

    renderVendorLocation = () => {
        return <>Vendor <br />Location </>
    }

    renderBasicRate = () => {
        return <>Basic <br />Rate(INR) </>
    }

    rendorFreightRate = () => {
        return <>RM Freight <br /> Cost(INR)</>
    }

    renderShearingCost = () => {
        return <>Shearing <br /> Cost(INR)</>
    }

    renderScrapRate = () => {
        return <>Scrap <br />Rate(INR) </>
    }

    renderNetCost = () => {
        return <>Net <br />Cost(INR) </>
    }

    renderEffectiveDate = () => {
        return <>Effective <br />Date</>
    }

    /**
   * @method dateFormatter
   * @description Renders date
   */
    dateFormatter = (cell, row, enumObject, rowIndex) => {
        return convertDate(cell);
    };

    /**
     * @method dateFormatter
     * @description Renders date
     */
    dateFormatter = (cell, row, enumObject, rowIndex) => cell === null ? '-' : convertDate(cell);

    render() {
        

        const options = {
            clearSearch: true,
            noDataText: <NoContentFound title={CONSTANT.EMPTY_DATA} />,
          };
        

        return (
            <>    
                <Row className="mt-4">
                    <Col>
                        <BootstrapTable
                            data={this.props.rmDataList}
                            striped={false}
                            bordered={false}
                            hover={false}
                            options={options}
                            search
                            multiColumnSearch={true}
                            // exportCSV={true}
                            ignoreSinglePage
                            // exportCSV={DownloadAccessibility}
                            exportCSV={this.props.isSimulation ? false : true}
                            csvFileName={"RmDomestic.csv"}
                            ref={'table'}
                            pagination>
                            <TableHeaderColumn dataField="CostingHead" width={100} columnTitle={true} dataAlign="left" searchable={false} dataSort={true} >{this.renderCostingHead()}</TableHeaderColumn>
                            <TableHeaderColumn dataField="RawMaterial" width={100} columnTitle={true} dataAlign="left" >{this.renderRawMaterial()}</TableHeaderColumn>
                            <TableHeaderColumn dataField="RMGrade" width={70} columnTitle={true} dataAlign="left" >{this.renderRMGrade()}</TableHeaderColumn>
                            <TableHeaderColumn width={100} columnTitle={true} dataAlign="left" dataField="RMSpec" >{this.renderRMSpec()}</TableHeaderColumn>
                            <TableHeaderColumn dataField="MaterialType" width={100} columnTitle={true} dataAlign="left" >{'Material'}</TableHeaderColumn>
                            <TableHeaderColumn width={100} columnTitle={true} dataAlign="left" dataField="Category" searchable={false} >Category</TableHeaderColumn>
                            <TableHeaderColumn width={100} columnTitle={true} dataAlign="left" dataField="TechnologyName" searchable={false} >Technology</TableHeaderColumn>
                            <TableHeaderColumn width={100} columnTitle={true} dataAlign="left" dataField="Plant" searchable={false} >{'Plant'}</TableHeaderColumn>
                            <TableHeaderColumn width={100} columnTitle={true} dataAlign="left" dataField="VendorName" >Vendor</TableHeaderColumn>
                            <TableHeaderColumn width={100} columnTitle={true} dataAlign="left" dataField="UOM" searchable={false} >UOM</TableHeaderColumn>
                            <TableHeaderColumn width={100} columnTitle={true} dataAlign="left" dataField="BasicRate" searchable={false} >{this.renderBasicRate()}</TableHeaderColumn>
                            <TableHeaderColumn width={100} columnTitle={true} dataAlign="left" dataField="RMFreightCost" dataFormat={this.freightCostFormatter} searchable={false}>{this.rendorFreightRate()}</TableHeaderColumn>
                            <TableHeaderColumn width={100} columnTitle={true} dataAlign="left" dataField="RMShearingCost" dataFormat={this.shearingCostFormatter} searchable={false}>{this.renderShearingCost()}</TableHeaderColumn>
                            <TableHeaderColumn width={100} columnTitle={true} dataAlign="left" dataField="ScrapRate" searchable={false} >{this.renderScrapRate()}</TableHeaderColumn>
                            <TableHeaderColumn width={120} columnTitle={true} dataAlign="left" dataField="NetLandedCost" searchable={false} dataFormat={this.costFormatter} >{this.renderNetCost()}</TableHeaderColumn>
                            <TableHeaderColumn width={100} columnTitle={true} dataAlign="left" searchable={false} dataField="EffectiveDate" dataSort={true} dataFormat={this.dateFormatter} >{this.renderEffectiveDate()}</TableHeaderColumn>
                            <TableHeaderColumn width={100} dataAlign="right" dataField="RawMaterialId" export={false} searchable={false} hidden isKey={true} dataFormat={this.buttonFormatter}>Actions</TableHeaderColumn>
                            <TableHeaderColumn width={100} columnTitle={true} dataAlign="left" searchable={false} dataSort={true} export={false} hidden dataField="VendorId"  >{''}</TableHeaderColumn>
                            <TableHeaderColumn width={100} columnTitle={true} dataAlign="left" searchable={false} dataSort={true} export={false} hidden dataField="TechnologyId"  >{''}</TableHeaderColumn>
                        </BootstrapTable>
                    </Col>
                </Row>  
            </>
        )
    }
}

export default RmDomesticListing;